import { render, staticRenderFns } from "./ProductsLowCategories.vue?vue&type=template&id=a0e91420&"
import script from "./ProductsLowCategories.vue?vue&type=script&lang=js&"
export * from "./ProductsLowCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports